var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPebF(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.374,
    height: 28.348,
    viewBox: "0 0 96.374 28.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "peb-f",
    transform: "translate(-0.679 -0.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M95.059,12.063l-18-11.44A2.837,2.837,0,0,0,75.282,0H8.749A8.787,8.787,0,0,0,0,8.8V19.547a8.786,8.786,0,0,0,8.749,8.8H75.282A2.827,2.827,0,0,0,77,27.766L95.007,16.881a2.834,2.834,0,0,0,.052-4.818",
    transform: "translate(0.679 0.692)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    "data-name": "Fill 2",
    d: "M18.591,0H0V22.678H18.591c0-.008,0-.014.006-.023L36.849,11.619,18.593.022c0-.008,0-.016,0-.022",
    transform: "translate(57.37 3.53)",
    fill: "#ec9441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M5.915,0A5.942,5.942,0,0,0,0,5.967V16.711a5.942,5.942,0,0,0,5.915,5.967H51.023V0H5.915",
    transform: "translate(3.513 3.528)",
    fill: "#3a484d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M.654,9.92A.57.57,0,0,1,0,9.276V.635A.572.572,0,0,1,.654,0h7.77A7.555,7.555,0,0,1,11.1.422c1.076.391,1.621.992,1.621,1.785V3.746A2.239,2.239,0,0,1,11.193,5.9a7.638,7.638,0,0,1-2.854.48H1.863v2.9a.551.551,0,0,1-.4.589A2.941,2.941,0,0,1,.654,9.92ZM1.863,1.475V4.887H8.448c1.61,0,2.426-.4,2.426-1.2V2.336c0-.572-.819-.861-2.435-.861Z",
    transform: "translate(9.689 9.907)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    "data-name": "Fill 5",
    d: "M11.54,4.961c0,.528-.233.789-.7.789H1.864V7.379q0,1.051,2.394,1.051h6.584a.574.574,0,0,1,.655.643c0,.566-.218.847-.655.847H4.174a6.928,6.928,0,0,1-2.678-.5A2.121,2.121,0,0,1,0,7.446V2.524A1.927,1.927,0,0,1,.5,1.239Q1.57,0,4.333,0H6.156C6.587,0,6.8.278,6.8.83a.57.57,0,0,1-.646.643h-.53l-.1-.006-.361-.014c-.1,0-.186,0-.253,0q-3.066,0-3.066,1.075V4.26h9a.614.614,0,0,1,.689.7",
    transform: "translate(23.125 9.907)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M8.566,9.92H.654A.575.575,0,0,1,0,9.276V.635A.572.572,0,0,1,.654,0h7.8a10.546,10.546,0,0,1,1.912.16,3.54,3.54,0,0,1,1.58.809A2.034,2.034,0,0,1,12.664,2.5,7.954,7.954,0,0,1,12.6,3.723a1.3,1.3,0,0,1-.108.244l-.022.038c-.06.106-.135.238-.231.394a3.259,3.259,0,0,0-.311.578,3.68,3.68,0,0,0,.311.514c.111.159.193.3.253.4a1,1,0,0,1,.108.253,2.565,2.565,0,0,1,.049.412c.012.174.017.405.017.728A2.244,2.244,0,0,1,11.27,9.393,6.153,6.153,0,0,1,8.566,9.92Zm-6.7-4.17V8.43h6.5c1.5,0,2.316-.316,2.421-.939a1.725,1.725,0,0,0,.012-.226c0-.118.005-.281.005-.488,0-.682-.778-1.028-2.313-1.028Zm.041-4.277V4.26h6.55c1.589,0,2.394-.31,2.394-.922,0-.177-.016-.448-.05-.83-.055-.687-.869-1.035-2.42-1.035Z",
    transform: "translate(35.698 9.907)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M1.936,1.729V4.168H5.852V5.894H1.936V9.922H0V0H6.536V1.729h-4.6",
    transform: "translate(68.275 9.907)",
    fill: "#1a1919"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPebF);
export default __webpack_public_path__ + "static/media/peb-f.605dd5960eb7c6572f37b5689967a5d3.svg";
export { ForwardRef as ReactComponent };